// Claves i18n del sistema — fuente única de strings de UI.
// Estructura jerárquica por módulo/componente/propiedad.
// Ver skill i18n: NUNCA literales en JSX, SIEMPRE referenciar vía es.<path>.

export const es = {
  app: {
    nombre: 'Panel de Control',
    organizacion: 'Metamorfosis Origen',
    equipo: 'AstroYoga',
    descripcion: 'Gestión integral de Metamorfosis Origen: ventas, contenido, reuniones y leads.',
    cargando: 'Cargando...',
  },
  tema: {
    cambiar: 'Cambiar tema',
    claro: 'Claro',
    oscuro: 'Oscuro',
    sistema: 'Sistema',
  },
  idioma: {
    cambiar: 'Cambiar idioma',
    espanol: 'Español',
    ingles: 'English',
  },
  nav: {
    inicio: 'Inicio',
    bandeja: 'Bandeja',
    publicar: 'Publicador',
    tareas: 'Tareas',
    conexiones: 'Conexiones',
    sistema: 'Sistema',
    usuarios: 'Usuarios',
    campanas: 'Campañas',
    anuncios: 'Anuncios',
    metricas: 'KPIs',
    miPerfil: 'Mi perfil',
    menuUsuario: 'Menú de usuario',
  },
  // Roles del sistema (etiquetas para UI).
  roles: {
    ADMINISTRADOR: 'Administrador',
    GERENCIA: 'Gerencia',
    LIDER: 'Líder',
    COLABORADOR: 'Colaborador',
    VISUALIZADOR: 'Visualizador',
  },
  // Auth
  auth: {
    login: {
      titulo: 'Iniciar sesión',
      tituloError: 'No pudimos iniciar sesión',
      email: 'Email',
      password: 'Contraseña',
      entrar: 'Entrar',
      entrando: 'Entrando...',
      olvideMiPassword: '¿Olvidaste tu contraseña? Contactá al administrador.',
      heroTitulo: 'Panel de Control',
    },
    cambiarPassword: {
      titulo: 'Cambiar contraseña',
      descripcion: 'Tenés que cambiar tu contraseña antes de continuar.',
      passwordActual: 'Contraseña actual',
      passwordNuevo: 'Contraseña nueva',
      passwordNuevoConfirmacion: 'Confirmar contraseña nueva',
      politicaAyuda: 'Mínimo 10 caracteres, con mayúscula, minúscula, número y símbolo.',
      guardar: 'Guardar',
      guardando: 'Guardando...',
      exito: 'Contraseña actualizada. Redirigiendo...',
    },
    logout: 'Salir',
  },
  // Admin
  admin: {
    usuarios: {
      titulo: 'Usuarios',
      crear: 'Crear usuario',
      cargando: 'Cargando usuarios...',
      vacio: 'No hay usuarios todavía.',
      sinResultados: 'No hay usuarios que coincidan con el filtro.',
      buscarPlaceholder: 'Buscar por nombre o email…',
      filtroEmailPlaceholder: 'Filtrar email…',
      filtroNombrePlaceholder: 'Filtrar nombre…',
      limpiar: 'Limpiar',
      filtroRolTodos: 'Todos los roles',
      filtroEstado: {
        todos: 'Todos',
        activos: 'Activos',
        inactivos: 'Inactivos',
      },
      totalSingular: 'usuario en total',
      totalPlural: 'usuarios en total',
      col: {
        email: 'Email',
        nombre: 'Nombre',
        rol: 'Rol',
        activo: 'Estado',
        acciones: 'Acciones',
        editar: 'Editar',
        resetPassword: 'Resetear contraseña',
      },
      estado: {
        activo: 'Activo',
        inactivo: 'Inactivo',
        debeCambiarPassword: 'Debe cambiar password',
      },
      crear_dialog: {
        titulo: 'Crear usuario',
        descripcion:
          'Si dejás la contraseña en blanco, generamos una temporal que vas a poder copiar al finalizar.',
        email: 'Email',
        nombre: 'Nombre y apellido',
        rol: 'Rol',
        rolPlaceholder: 'Elegir rol...',
        crear: 'Crear',
        creando: 'Creando...',
        cancelar: 'Cancelar',
        cerrar: 'Cerrar',
        copiar: 'Copiar',
        copiada: 'Contraseña copiada al portapapeles',
        exito: 'Usuario creado',
        errorEmailEnUso: 'Ya existe un usuario con ese email',
        passwordGeneradaTitulo: 'Contraseña temporal generada',
        passwordGeneradaDescripcion:
          'Esta es la única vez que vas a verla. Copiala y comunicásela al usuario por un canal seguro.',
      },
      editar_dialog: {
        titulo: 'Editar usuario',
        nombre: 'Nombre y apellido',
        rol: 'Rol',
        activo: 'Estado',
        guardar: 'Guardar cambios',
        guardando: 'Guardando...',
        cancelar: 'Cancelar',
        exito: 'Usuario actualizado',
      },
      reset_dialog: {
        titulo: 'Resetear contraseña',
        advertencia:
          'Vas a generar una contraseña temporal nueva y el usuario va a tener que cambiarla al próximo login. Los intentos fallidos y el lockout se reinician.',
        resetear: 'Resetear contraseña',
        reseteando: 'Reseteando...',
        cancelar: 'Cancelar',
        cerrar: 'Cerrar',
        copiar: 'Copiar',
        copiada: 'Contraseña copiada al portapapeles',
        exito: 'Contraseña reseteada',
        generadaTitulo: 'Contraseña temporal generada',
        generadaDescripcion:
          'Esta es la única vez que vas a verla. Copiala y comunicásela al usuario por un canal seguro.',
      },
    },
    campanas: {
      titulo: 'Anuncios',
      intro:
        'De dónde vienen los leads. Cada anuncio sella a las personas que trae: por el texto del anuncio, por el metadato de Meta o por la plantilla que mandaba el Emisor de n8n. Las campañas que manda la app están en Campañas.',
      crear: 'Nuevo anuncio',
      cargando: 'Cargando campañas...',
      vacio: 'No hay campañas.',
      columnas: {
        nombre: 'Nombre',
        tipo: 'Tipo',
        numeros: 'Números',
        vigencia: 'Vigencia',
        textos: 'Textos',
        leads: 'Leads',
        activa: 'Activa',
      },
      tipos: {
        META_ADS: 'Meta Ads',
        REAPERTURA: 'Reapertura (Emisor n8n)',
        EMISION: 'Envío desde la app',
      },
      sinHasta: 'sin fin',
      activar: 'Activar',
      desactivar: 'Desactivar',
      actualizada: 'Campaña actualizada',
      verTextos: '{n} texto(s)',
      editar: 'Editar',
      dialogo: {
        titulo: 'Nueva campaña',
        nombre: 'Nombre',
        tipo: 'Tipo',
        numeros: 'Números por los que corre',
        textos: 'Textos que identifican al lead',
        textosAyuda:
          'Separá cada texto con una línea en blanco. Para Meta Ads: el mensaje prefijado del anuncio. Para reapertura: las plantillas del Emisor (podés usar {{nombre}}).',
        vigenteDesde: 'Vigente desde',
        vigenteHasta: 'Vigente hasta (opcional)',
        cancelar: 'Cancelar',
        crear: 'Crear campaña',
        creando: 'Creando...',
        exito: 'Campaña creada',
        errorNombreEnUso: 'Ya existe una campaña con ese nombre.',
        errorNumeros: 'Elegí al menos un número.',
        errorNombre: 'El nombre tiene que tener al menos 2 caracteres.',
      },
      editarDialogo: {
        titulo: 'Editar campaña',
        textos: 'Textos que identifican al lead',
        textosAyuda:
          'Separá cada texto con una línea en blanco. El nombre, tipo y números no se pueden cambiar — si hace falta, creá una campaña nueva.',
        vigenteHasta: 'Vigente hasta (opcional)',
        cancelar: 'Cancelar',
        guardar: 'Guardar cambios',
        guardando: 'Guardando...',
        exito: 'Campaña actualizada',
        errorTextos: 'Cada texto tiene que tener al menos 3 caracteres.',
      },
    },
    metricas: {
      titulo: 'KPIs',
      intro: 'Mensajes, tasa de respuesta y tasa de bloqueo. Filtrá por fecha o mirá todo el histórico.',
      campana: 'Campaña',
      todasLasCampanas: 'Todas las campañas',
      desde: 'Desde',
      hasta: 'Hasta',
      limpiarFiltro: 'Ver todo',
      cargando: 'Calculando...',
      recontacto: {
        titulo: 'Recontacto AstroYoga',
        intro:
          'El histórico de la campaña AstroYoga (el Emisor de n8n sobre Notion Master Leads, no scrapeados con teléfono). Se lee de la foto que quedó en la base al congelar Notion: ya no cambia. Las campañas nuevas muestran sus resultados en Campañas.',
        aContactar: 'Leads a contactar',
        contactados: 'Contactados',
        pendientes: 'Pendientes',
        convertidos: 'Convertidos',
        tasaBloqueo: 'Nos bloquearon',
        tasaBloqueoAyuda:
          '{bloqueados} de {contactados} contactados por el Emisor quedaron sin entregar 48 h',
        losBloqueamos: 'Los bloqueamos nosotros',
        losBloqueamosAyuda:
          'eliminados desde la app · aparte, {antes} marcados "me bloqueó" antes de la campaña (no cuentan)',
      },
      app: {
        titulo: 'Meta Ads y la app',
        intro: 'Lo que pasa por esta app: los leads del anuncio y las conversaciones de la bandeja.',
      },
      tarjetas: {
        mensajesEnviados: 'Mensajes enviados',
        mensajesRecibidos: 'Mensajes recibidos',
        tasaRespuesta: 'Tasa de respuesta',
        tasaRespuestaAyuda: '{respondieron} de {contactados} leads contactados respondieron',
        yaContactados: 'Ya contactados',
        pendientes: 'Pendientes de contactar',
        deTotal: 'de {total} leads',
        tasaBloqueo: 'Tasa de bloqueo',
        tasaBloqueoAyuda: '{bloqueados} de {total} leads del período',
      },
    },
  },
  // Errores comunes
  // Bandeja de leads (Ciclo 1)
  bandeja: {
    titulo: 'Bandeja de leads',
    buscar: 'Buscar por nombre o teléfono',
    sinLeads: 'Todavía no escribió nadie.',
    sinResultados: 'Ningún lead coincide con la búsqueda.',
    elegiUnLead: 'Elegí una conversación de la lista.',
    cargando: 'Cargando...',
    errorCarga: 'No pudimos cargar la bandeja.',
    sinNombre: 'Sin nombre',
    sinTelefono: 'Número oculto por WhatsApp',
    noLeidos: '{n} sin leer',
    campana: 'Campaña',
    todasLasCampanas: 'Todas',
    // Filtro por etapa (30/09/2026, pedido de Javier), independiente de las
    // pestañas de estado (`etiquetas`/`filtros` abajo). Los nombres de cada
    // etapa salen de `etapas` (ya existe, lo usa ChipEtapa), acá abajo.
    todasLasEtapas: 'Todas',
    etiquetas: 'Etiquetas',
    // El panel de campaña/etapa/etiqueta/orden se puede ocultar (01/10/2026,
    // pedido de Javier): ocupaba espacio fijo aunque se configura una sola vez.
    filtrosBtn: 'Filtros',
    filtrosNinguno: 'ninguno aplicado',
    // Pedido de Ailén (01/10/2026): por fecha se va reordenando con cada mensaje
    // nuevo y se le mezclan los leads a mitad de un recontacto; alfabético los
    // deja quietos en su lugar mientras va escribiéndole a cada uno.
    orden: {
      titulo: 'Orden',
      fecha_desc: 'Más recientes primero',
      fecha_asc: 'Más antiguos primero',
      alfabetico_asc: 'Alfabético (A-Z)',
      alfabetico_desc: 'Alfabético (Z-A)',
    },
    filtros: {
      todos: 'Todos',
      nuevos: 'Nuevos',
      activos: 'Activos',
      esperando: 'Esperando',
      recontactados: 'Recontactos',
      cerrados: 'Cerrados',
      historial: 'Historial',
      bloqueados: 'Eliminados',
    },
    estados: {
      NUEVO: 'Nuevo',
      ACTIVO: 'Activo',
      ESPERANDO_RESPUESTA: 'Esperando respuesta',
      RECONTACTO_1: 'Recontacto 1',
      RECONTACTO_2: 'Recontacto 2',
      CERRADO_GANADO: 'Ganado',
      CERRADO_NO_INTERESADO: 'No le interesó',
      CERRADO_SIN_RESPUESTA: 'Sin respuesta',
      DERIVADO_SALUD: 'Derivado (salud)',
      HISTORICO: 'Historial',
      BLOQUEADO: 'Eliminado',
    },
    fuentes: {
      META_ADS: 'Meta Ads',
      ORGANICO: 'Orgánico',
      RECONTACTO_CAMPANA: 'Campaña de reapertura',
    },
    deteccion: {
      AD_METADATA: 'por el anuncio',
      TEXTO: 'por el texto',
      VIGENCIA: 'campaña vigente',
      PLANTILLA: 'por la plantilla del Emisor',
      FALLBACK: 'número nuevo durante la campaña',
      NINGUNA: '',
    },
    etapa: 'Etapa',
    etapas: {
      1: 'Contacto',
      2: 'Profundizar',
      3: 'Validar',
      4: 'Propuesta',
      5: 'Cierre',
    },
    tipoRecibido: {
      // El audio con archivo disponible se reproduce (ver BurbujaMensaje); esto
      // es el aviso cuando no hay archivo (falló la descarga o venció la retención).
      AUDIO: 'Audio no disponible',
      IMAGEN: 'Imagen recibida — mirala en el celular',
      VIDEO: 'Video recibido — miralo en el celular',
      DOCUMENTO: 'Documento recibido',
      STICKER: 'Sticker',
      OTRO: 'Mensaje no soportado',
    },
    // ciclo-historial-fiel: lo que pasó en WhatsApp después de mandarlo.
    editado: 'editado',
    textoAntesDeEditar: 'Antes decía:',
    eliminado: 'Mensaje eliminado en WhatsApp',
    editadoSinTexto: 'Editado en WhatsApp: el texto nuevo no llega a la app, miralo en el celular',
    enviadoPor: {
      OPERADORA: 'desde la app',
      TELEFONO: 'desde el celular',
      RECONTACTO_AUTO: 'recontacto automático',
      SISTEMA_APERTURA: 'apertura automática',
      CAMPANA: 'campaña',
      LEAD: '',
    },
    compositor: {
      placeholder: 'Escribí la respuesta… (Enter envía, Shift+Enter hace un salto de línea)',
      enviar: 'Enviar',
      enviando: 'Enviando...',
      enviado: 'Mensaje enviado',
      errorEnvio: 'No se pudo enviar. WhatsApp no respondió; probá de nuevo.',
      cerrado: 'Este lead está cerrado. Si escribís, se reabre.',
      bloqueado: 'Este contacto fue eliminado. No se le puede volver a escribir.',
    },
    // Ciclo 2 (D-023/024/025): la sugerencia que precarga el compositor.
    sugerencia: {
      aviso: 'Este mensaje lo propuso el sistema — revisalo antes de mandarlo.',
      // 01/10/2026: si ya estabas escribiendo lo tuyo, la sugerencia no se precarga
      // sola (ver Compositor); este botón la trae al compositor a pedido.
      usar: 'Usar este texto',
      // Slice B (D-027): calificación de 1 a 5 estrellas. {n} se reemplaza en el uso
      // (mismo patrón que `acciones.sincronizado`, el diccionario no soporta funciones).
      calificarEstrella: 'Calificar esta sugerencia con {n} de 5 estrellas',
      // Botón "generar ahora" (29/09/2026): salta la ventana de agrupación.
      generarAhora: 'Generar sugerencia ahora',
      generando: 'Generando…',
      esperando: 'Esperando el mensaje siguiente antes de sugerir…',
      // Fix 29/09: el botón antes solo aparecía con ventana programada (solo pasa
      // en leads Meta Ads). Ahora se ve siempre que no hay sugerencia; este es el
      // texto para cuando no hay ninguna ventana corriendo.
      sinSugerencia: 'Todavía no hay una sugerencia para este lead.',
    },
    audio: {
      grabar: 'Grabar audio',
      grabando: 'Grabando',
      detener: 'Detener grabación',
      cancelar: 'Cancelar grabación',
      descartar: 'Descartar',
      enviar: 'Enviar audio',
      enviando: 'Enviando audio...',
      permisoDenegado: 'No se pudo acceder al micrófono. Revisá los permisos del navegador.',
      errorEnvio: 'No se pudo enviar el audio. Probá de nuevo.',
    },
    acciones: {
      cerrar: 'Cerrar lead',
      cerrarGanado: 'Cerrar como ganado',
      cerrarNoInteresado: 'Cerrar: no le interesó',
      cerrado: 'Lead cerrado',
      errorCerrar: 'No se pudo cerrar el lead.',
      cambiarEtapa: 'Cambiar etapa',
      sincronizar: 'Sincronizar con WhatsApp',
      sincronizando: 'Sincronizando...',
      sincronizado: 'Sincronizado: {procesados} nuevos, {duplicados} ya estaban, {ignorados} ignorados.',
      // Deploy 29/09: el botón que enlaza a /bandeja/indicadores ya estaba commiteado
      // en develop pero le faltaba esta clave (bloqueaba el build). Repuesta con el
      // mismo texto que tenía en el trabajo sin commitear que la agregó.
      indicadores: 'Indicadores',
      eliminar: 'Eliminar contacto',
      eliminado: 'Contacto eliminado',
      errorEliminar: 'No se pudo eliminar el contacto.',
    },
    eliminarDialogo: {
      titulo: 'Eliminar contacto',
      descripcion:
        'Se oculta de la bandeja y nunca más se le va a escribir desde acá. El registro queda guardado.',
      motivo: 'Motivo (obligatorio)',
      motivoPlaceholder: 'Ej.: contenido inapropiado, pidió que no lo contacten más...',
      errorMotivo: 'Contá brevemente el motivo (al menos 3 caracteres).',
      cancelar: 'Cancelar',
      confirmar: 'Eliminar',
      eliminando: 'Eliminando...',
    },
    // ciclo-calidad-leads (R6): el ícono de la charla y su pop-up.
    calidad: {
      abrir: 'Calificar lead',
      explicacion: 'Calificá este lead para mejorar los leads que trae Meta.',
      opciones: { SIN_CALIFICAR: 'Sin calificar', BUENO: 'Bueno', BASURA: 'Basura', COMPRO: 'Compró' },
      porQue: '¿Por qué?',
      motivos: {
        DESINTERESADO: 'Desinteresado',
        BUSCA_OTRA_COSA: 'Busca otra cosa',
        FUERA_DE_ZONA: 'Fuera de zona',
        SPAM: 'Spam',
        INAPROPIADO: 'Inapropiado',
      },
      deshacer: 'Quitar calificación',
      error: 'No se pudo guardar la calificación.',
    },
    tiempo: {
      ahora: 'ahora',
      minutos: 'hace {n} min',
      horas: 'hace {n} h',
      ayer: 'ayer',
      dias: 'hace {n} días',
    },
    numeros: {
      enviarDesde: 'Enviar desde',
      preferido: 'Número por defecto de esta persona',
      fijarPreferido: 'Usar este número de ahora en más',
      chatPor: 'Chat por {etiqueta}',
      vista: 'Ver',
      ambos: 'Ambos',
      sinMensajes: 'Todavía no hay mensajes por este número.',
      cambioAviso: 'Vas a escribirle por otro número del que usa. Solo si es a propósito.',
    },
    conexion: {
      enVivo: 'En vivo',
      reconectando: 'Reconectando...',
    },
  },
  errores: {
    auth: {
      credenciales: 'Credenciales inválidas',
      bloqueado: 'Tu cuenta está bloqueada temporalmente. Probá de nuevo en unos minutos.',
      tasaLimite: 'Estás haciendo esto muy seguido — esperá unos segundos antes de reintentar.',
      sinPermiso: 'No tenés permiso para esta acción',
      sinPermisoDetalle: 'Si pensás que es un error, hablá con tu administrador.',
    },
    locking: {
      conflicto: 'Otro usuario editó esto mientras vos trabajabas. ¿Querés ver los cambios?',
    },
    generico: {
      algoSalioMal: 'Algo falló — ya quedó registrado, intentá de nuevo.',
    },
  },
  // Errores del sistema (admin)
  erroresAdmin: {
    titulo: 'Errores del sistema',
    descripcion:
      'Errores no esperados (500) capturados automáticamente. Marcá como resuelto los que ya tengan fix.',
    cargando: 'Cargando errores...',
    vacio: 'No hay errores registrados.',
    filtros: {
      todos: 'Todos',
      noResueltos: 'No resueltos',
      resueltos: 'Resueltos',
    },
    col: {
      fecha: 'Fecha',
      nivel: 'Nivel',
      mensaje: 'Mensaje',
      path: 'Endpoint',
      estado: 'Estado',
      acciones: '',
    },
    estado: {
      resuelto: 'Resuelto',
      pendiente: 'Pendiente',
    },
    detalle: 'Ver detalle',
    marcarResuelto: 'Marcar resuelto',
    marcarPendiente: 'Marcar pendiente',
    notas: 'Notas (opcional)',
    placeholderNotas: 'Ej: "Fix en PR-123 — bug en parser de fechas"',
    guardar: 'Guardar',
    cancelar: 'Cancelar',
    exitoResolver: 'Estado actualizado',
    stack: 'Stack trace',
    request: 'Request',
    contexto: 'Contexto',
  },
  configuracionAdmin: {
    titulo: 'Configuración del sistema',
    descripcion: 'Variables runtime del sistema (key-value). Cambios quedan auditados.',
    cargando: 'Cargando configuración...',
    vacio: 'No hay configuración registrada.',
    col: {
      clave: 'Clave',
      valor: 'Valor (JSON)',
      descripcion: 'Descripción',
      actualizadoEn: 'Última actualización',
    },
    editar: 'Editar',
    guardar: 'Guardar',
    cancelar: 'Cancelar',
    exito: 'Configuración actualizada',
    invalidJson: 'JSON inválido — revisar formato.',
    integracion: {
      titulo: 'Integración con otras apps',
      apiKeys: 'API keys',
      apiKeysDesc: 'Crear y revocar credenciales para que otras apps consuman la API.',
      docs: 'Documentación de la API (OpenAPI)',
    },
  },
  // H-04 — API keys
  apiKeys: {
    titulo: 'API keys',
    descripcion:
      'Credenciales para integrar otras aplicaciones. Cada key actúa con un rol asignado ' +
      '(mismos permisos que ese rol). Se envía en el header X-API-Key.',
    docs: 'Ver documentación de la API',
    crear: 'Crear API key',
    cargando: 'Cargando API keys...',
    vacio: 'Todavía no hay API keys.',
    col: {
      nombre: 'Nombre',
      prefijo: 'Prefijo',
      rol: 'Rol',
      estado: 'Estado',
      ultimoUso: 'Último uso',
      creadoPor: 'Creada por',
    },
    activa: 'Activa',
    revocada: 'Revocada',
    nunca: 'Nunca',
    revocar: 'Revocar',
    confirmarRevocar: '¿Revocar esta API key? Las apps que la usen dejarán de funcionar.',
    revocada_exito: 'API key revocada',
    dialog: {
      titulo: 'Crear API key',
      nombre: 'Nombre',
      nombrePlaceholder: 'Ej: Integración Power BI',
      rol: 'Rol (permisos de la key)',
      crear: 'Crear',
      cancelar: 'Cancelar',
    },
    creada: {
      titulo: 'Copiá la API key ahora',
      aviso: 'Esta es la única vez que se muestra la key completa. Guardala en un lugar seguro.',
      copiar: 'Copiar',
      copiado: 'Copiado',
      cerrar: 'Listo',
    },
  },
  notificaciones: {
    titulo: 'Notificaciones',
    abrirPanel: 'Abrir notificaciones',
    contadorTooltip: 'notificaciones sin leer',
    vacio: 'No tenés notificaciones.',
    marcarTodasLeidas: 'Marcar todas como leídas',
    marcarLeida: 'Marcar como leída',
    irAlContexto: 'Ir al contexto',
    soloNoLeidas: 'Solo no leídas',
    todas: 'Todas',
    tipos: {
      SISTEMA: 'Sistema',
      PUBLICACION: 'Publicación',
      CONEXION: 'Conexión',
      CAMPANA: 'Campaña',
    },
  },
  conexiones: {
    probar: 'Probar conexiones',
    probando: 'Probando...',
    exito: 'Listo.',
    columnas: {
      conexion: 'Conexión',
      estado: 'Estado',
      ultimoUso: 'Último uso exitoso',
      ultimaPrueba: 'Última prueba',
      detalle: 'Detalle',
    },
    estados: {
      OK: 'OK',
      ERROR: 'Error',
      SIN_PROBAR: 'Sin probar',
    },
    nombres: {
      GOOGLE_DRIVE: 'Google Drive',
      YOUTUBE: 'YouTube',
      GEMINI: 'Gemini',
      META_ADS: 'Meta Ads',
      EVOLUTION: 'WhatsApp (Evolution)',
      BUFFER: 'Buffer (TikTok/Instagram/Facebook)',
    },
    nunca: 'nunca',
  },
  // "Mi perfil".
  perfil: {
    titulo: 'Mi perfil',
    cargando: 'Cargando perfil...',
    datosPersonales: {
      titulo: 'Datos personales',
      descripcion: 'Editá tu nombre y tu foto. El email y el rol los gestiona un administrador.',
      nombre: 'Nombre',
      email: 'Email',
      rol: 'Rol',
      guardar: 'Guardar cambios',
      guardando: 'Guardando...',
      exito: 'Perfil actualizado.',
    },
    avatar: {
      titulo: 'Foto de perfil',
      subir: 'Subir foto',
      cambiar: 'Cambiar foto',
      quitar: 'Quitar foto',
      subiendo: 'Subiendo...',
      quitando: 'Quitando...',
      ayuda: 'JPEG, PNG o WebP. Máximo 2 MB.',
      exitoSubida: 'Foto actualizada.',
      exitoQuitada: 'Foto quitada.',
      errorFormato: 'Solo se permiten imágenes JPEG, PNG o WebP.',
      errorTamanio: 'La imagen supera el máximo de 2 MB.',
      alt: 'Foto de perfil',
    },
    password: {
      titulo: 'Contraseña',
      descripcion: 'Para mayor seguridad, cambiá tu contraseña periódicamente.',
      cambiar: 'Cambiar contraseña',
    },
  },
  // ciclo-panel: la home como panel de control
  inicio: {
    saludo: 'Hola, {nombre}',
    intro: 'Todo lo que usás, en un lugar.',
    accesos: {
      ventas: { titulo: 'Ventas', detalle: 'La bandeja de WhatsApp: leads, respuestas y recontactos' },
      publicar: {
        titulo: 'Publicador',
        detalle: 'Cargá un reel, un carrusel o una historia y se publica sola',
      },
      reuniones: { titulo: 'Reuniones', detalle: 'Las clases y charlas por video, en Meet' },
      tareas: { titulo: 'Tareas', detalle: 'Tus prioridades de la semana, tarjeta por tarjeta' },
      campanas: {
        titulo: 'Campañas',
        detalle: 'Mensajes de WhatsApp a una lista, con sus resultados a la vista',
      },
    },
    abrirEnPestana: 'Se abre en otra pestaña',
  },
  // ciclo-emisor, parte 2: las campañas de envío (la app le escribe a una lista fija).
  campanasEnvio: {
    titulo: 'Campañas',
    intro:
      'Mensajes de WhatsApp que manda la app a una lista fija, a su ritmo. Vos decidís si siguen o se bajan, mirando los resultados.',
    nueva: 'Nueva campaña',
    cargando: 'Cargando campañas...',
    vacio: 'Todavía no hay campañas. Armá la primera con "Nueva campaña".',
    estados: { BORRADOR: 'Borrador', ACTIVA: 'Activa', PAUSADA: 'Pausada', TERMINADA: 'Terminada' },
    activa: 'Activa',
    progreso: '{enviados} de {total} enviados',
    sinLista: 'La lista se fija al activarla',
    verDetalle: 'Ver resultados',
    editar: 'Editar',
    activada: 'Campaña activada: en un minuto fija la lista y empieza a mandar',
    pausada: 'Campaña pausada',
    confirmarActivar: {
      titulo: '¿Activar "{nombre}"?',
      cuerpo:
        'La lista queda fija en este momento: las personas que cumplen los filtros ahora. Después se pueden cambiar el ritmo y los mensajes, pero no a quién le llega.',
      confirmar: 'Activar',
      cancelar: 'Cancelar',
    },
    resultados: {
      enviados: 'Enviados',
      entregados: 'Entregados',
      respondieron: 'Respondieron',
      avanzaron: 'Avanzaron',
      compraron: 'Compraron',
      noEntregados: 'Nos bloquearon',
      noEntregadosAyuda:
        'No llegaron en 48 h. WhatsApp no avisa los bloqueos: esta es la única señal (también puede ser un teléfono apagado).',
      sinWhatsApp: 'Sin WhatsApp',
      salteados: 'Salteados',
      pendientes: 'Por mandar',
    },
    editor: {
      tituloNueva: 'Nueva campaña',
      tituloEditar: 'Editar campaña',
      nombre: 'Nombre',
      nombrePlaceholder: 'Ej: Taller noviembre',
      pasoQuien: '1. A quién',
      pasoMensajes: '2. Mensajes',
      pasoRitmo: '3. Ritmo',
      pasoProbar: '4. Probar',
      listaFija: 'La lista quedó fija al activarla: a quién le llega ya no se cambia.',
      guardar: 'Guardar',
      guardado: 'Campaña guardada',
      volver: 'Volver',
    },
    filtros: {
      quienes: 'Quiénes',
      origenes: {
        APP: 'Nos escribieron (app)',
        NOTION: 'Históricos de Notion',
        SCRAPER: 'Negocios del scraper',
      },
      avisoScraper:
        'Son negocios sacados de Google Maps, no personas que nos escribieron. Escribirles en frío es lo que más bloqueos trae, y unos 90 de esos teléfonos tienen mal el prefijo de país.',
      ultimoEntrante: 'Último mensaje de la persona',
      rangos: {
        MENOS_30: 'Menos de 30 días',
        DE_30_A_90: '30 a 90 días',
        MAS_90: 'Más de 90 días',
        NUNCA: 'Nunca nos escribió',
      },
      etapa: 'Etapa',
      desde: 'desde',
      hasta: 'hasta',
      calidad: 'Calidad',
      calidades: { SIN_CALIFICAR: 'Sin calificar', BUENO: 'Bueno', BASURA: 'Basura', COMPRO: 'Compró' },
      fuente: 'Vino por',
      fuentes: { META_ADS: 'Anuncio de Meta', ORGANICO: 'Orgánico', RECONTACTO_CAMPANA: 'Recontacto' },
      campanaOrigen: 'Campaña de origen',
      ninguna: 'Ninguna',
      pais: 'País',
      descanso: 'Descanso',
      descansoAyuda: 'Que no haya recibido ninguna campaña en los últimos',
      dias: 'días',
      cualquiera: 'Sin marcar ninguno, no filtra.',
      siempre:
        'Siempre quedan afuera: bloqueados, los que compraron, basura, derivados a salud, los que dijeron que no, charlas abiertas con Ailén y a quien le escribimos hace menos de 3 días.',
    },
    audiencia: {
      llegaria: 'Le llegaría a {n} personas',
      calculando: 'Calculando...',
      excluidos: 'Pasan los filtros pero quedan afuera:',
      verMuestra: 'Ver 10 de ejemplo',
      ocultarMuestra: 'Ocultar',
      sinNombre: '(sin nombre)',
    },
    plantillas: {
      ayuda:
        'En cada envío se elige una al azar entre las activas. {{nombre}} se cambia por el primer nombre; si la persona no tiene nombre, se saca el "Hola {{nombre}},".',
      agregar: 'Agregar plantilla',
      nombre: 'Nombre',
      texto: 'Texto',
      activa: 'Activa',
      vistaPrevia: 'Así le llega a Ana:',
      vistaPreviaSinNombre: 'Y a alguien sin nombre:',
      nueva: 'Plantilla {n}',
    },
    ritmo: {
      topeDiario: 'Mensajes por día',
      intervalo: 'Minutos entre mensajes',
      franja: 'Horario (Argentina)',
      de: 'de',
      a: 'a',
      horas: 'h',
      hasta: 'Termina el',
      ayudaTope: 'Además, cada número de WhatsApp manda como mucho 10 por día, sumando todas las campañas.',
    },
    prueba: {
      ayuda:
        'Te manda el texto ya, solo a vos. No cuenta para la campaña. El número tiene que haberle escrito alguna vez a Metamorfosis.',
      numero: 'Tu número',
      plantilla: 'Plantilla',
      enviar: 'Enviarme una prueba',
      enviada: 'Prueba enviada por {instancia}',
    },
    detalle: {
      volver: 'Campañas',
      envios: 'A quién se le mandó',
      columnas: {
        persona: 'Persona',
        estado: 'Estado',
        numero: 'Número',
        enviado: 'Enviado',
        respondio: 'Respondió',
      },
      estadosEnvio: {
        PENDIENTE: 'Por mandar',
        ENVIADO: 'Enviado',
        ENTREGADO: 'Entregado',
        NO_ENTREGADO_48H: 'No llegó (48 h)',
        SIN_WHATSAPP: 'Sin WhatsApp',
        SALTEADO: 'Salteado',
      },
      verCharla: 'Ver charla',
      si: 'Sí',
      ritmoActual: '{tope} por día · cada {intervalo} min · de {inicio} a {fin} h',
      sinEnvios: 'Todavía no hay nadie en esta vista.',
      mostrar: 'Mostrar',
      todos: 'Todos',
    },
  },
  // Embudo de ventas + costos de Meta Ads (ciclo-metricas-embudo-y-contenido, R5,
  // 28-29/09/2026). Vive en /bandeja/indicadores — sin título ni subtítulo (CLAUDE.md §5.8).
  embudo: {
    volver: 'Volver a la bandeja',
    campana: 'Campaña',
    filtrarPorFecha: 'Filtrar por fecha',
    desde: 'Desde',
    hasta: 'Hasta',
    limpiarFiltro: 'Ver todo',
    cargando: 'Cargando...',
    costoPorMensaje: 'Costo por mensaje',
    costoPorCliente: 'Costo por cliente cerrado',
    sinDatos: 'Sin datos todavía',
    etapas: {
      '1': 'Contacto',
      '2': 'Profundizar',
      '3': 'Validar',
      '4': 'Propuesta',
      5: 'Cierre',
    },
    gastoPorDia: 'Gasto de la campaña por día',
    gastoTotal: 'Total: {monto}',
    etapaPrefijo: 'ETAPA',
    leads: 'leads',
    // Franjas de "% avanza" entre etapas, en semáforo (D-030).
    avanza: 'avanza',
    enRango: 'en rango',
    revisar: 'revisar',
    vigilar: 'vigilar',
    muestraChica: 'muestra chica',
    sinCierres: 'Todavía nadie llegó a esta etapa en este rango.',
    // Pie del embudo (D-035): de los que llegaron a la etapa 5, cómo terminaron.
    ganados: 'Ganados',
    perdidos: 'Perdidos',
    enProceso: 'En proceso',
    // ciclo-calidad-leads (R7): calidad y costo por lead bueno.
    calidad: {
      porAnuncio: 'Calidad por anuncio',
      porCampana: 'Calidad por campaña',
      anuncio: 'Anuncio',
      campana: 'Campaña',
      leads: 'Leads',
      buenos: 'Buenos',
      basura: 'Basura',
      sinCalificar: 'Sin calificar',
      sinRespuesta: 'No respondieron',
      gasto: 'Gasto',
      costoPorLeadBueno: 'Costo por lead bueno',
      sinAnuncio: 'Sin anuncio identificado',
      sinNombre: 'Anuncio {id}',
      total: 'Total',
      vacio: 'Todavía no hay leads de Meta ni gasto en este rango.',
      muestra: 'de {n} calificados',
    },
  },
  publicar: {
    titulo: 'Publicador de contenido',
    intro: 'Elegí el archivo, escribí el texto y decí cuándo. De subirlo y publicarlo se encarga el sistema.',
    formato: { etiqueta: 'Qué vas a publicar', REEL: 'Reel', CARRUSEL: 'Carrusel', HISTORIA: 'Historia' },
    archivo: {
      etiqueta: 'El archivo',
      etiquetaCarrusel: 'Las imágenes, en orden',
      arrastrar: 'Arrastrá acá o hacé clic para elegir',
      ayudaReel: 'Un video (mp4 o mov), hasta 95 MB',
      ayudaHistoria: 'Una imagen o un video, hasta 95 MB',
      ayudaCarrusel: 'Varias imágenes (jpg o png). Se publican en este orden',
      quitar: 'Quitar',
      subir: 'Mover arriba',
      bajar: 'Mover abajo',
      muyGrande: 'Ese archivo supera los 95 MB',
      tipoInvalido: 'Ese tipo de archivo no va con este formato',
    },
    tituloCampo: 'Título',
    tituloAyuda: 'Es interno: con esto se nombra el archivo y se ordena la lista',
    caption: 'Texto de la publicación',
    captionContador: '{n} de 2.200',
    hashtags: 'Hashtags',
    hashtagsAyuda: 'Separados por espacio. Van al final del texto',
    redes: {
      etiqueta: 'Dónde',
      INSTAGRAM: 'Instagram',
      TIKTOK: 'TikTok',
      YOUTUBE: 'YouTube',
      FACEBOOK: 'Facebook',
      ayudaYoutube: 'YouTube solo recibe video',
    },
    pilar: {
      etiqueta: 'Pilar',
      ninguno: 'Sin pilar',
      ALCANCE: 'Alcance',
      POSICIONAMIENTO: 'Posicionamiento',
      CONVERSION: 'Conversión',
    },
    modo: { etiqueta: 'Cuándo', PROGRAMAR: 'Programar', PUBLICAR_YA: 'Publicar ya' },
    fecha: 'Fecha',
    hora: 'Hora',
    notas: 'Notas internas',
    notasAyuda: 'No se publican',
    boton: 'Publicar',
    subiendo: 'Subiendo… {pct}%',
    faltan: 'Antes de publicar:',
    listo: {
      ya: 'Listo: se publica en las próximas horas en {redes}.',
      programado: 'Listo: se publica el {fecha} a las {hora} en {redes}.',
      horizonte:
        'Listo: queda programado para el {fecha} a las {hora}. El sistema lo toma cuando falten 5 días.',
      otra: 'Cargar otra',
    },
    pestanas: {
      cargar: 'Cargar',
      log: 'Log de cargas',
      calendario: 'Calendario',
      indicadores: 'Indicadores',
    },
    // Indicadores de contenido orgánico (ciclo-metricas-embudo-y-contenido, R6, 28-29/09/2026):
    // promedio semanal de alcance/visualizaciones/interacciones/tiempo de reproducción.
    indicadores: {
      rango: {
        semana: 'Última semana',
        mes: 'Último mes',
        tresMeses: 'Últimos 3 meses',
        personalizado: 'Personalizado',
      },
      alcance: 'Alcance',
      visualizaciones: 'Visualizaciones',
      interacciones: 'Interacciones',
      tiempoReproduccion: 'Tiempo de reproducción',
      publicaciones: '{n} publicaciones',
      sinPublicaciones: 'Sin publicaciones esta semana',
      cargando: 'Cargando...',
      sinDatos: 'Todavía no hay datos de contenido — el primer sync puede tardar hasta 24 h.',
      sinRedes: 'Elegí al menos una red para ver los indicadores.',
      segundos: 's',
    },
    calendario: {
      mesAnterior: 'Mes anterior',
      mesSiguiente: 'Mes siguiente',
      hoy: 'Hoy',
      vistas: { dia: 'Día', semana: 'Semana', mes: 'Mes' },
      semanaDel: 'Semana del {desde} al {hasta}',
      sinDia: 'Sin publicaciones ese día.',
      dias: 'Lun|Mar|Mié|Jue|Vie|Sáb|Dom',
      meses: 'enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre',
      vacio: 'Sin publicaciones este mes.',
      mas: '+{n} más',
    },
    lista: {
      titulo: 'Lo que ya cargaste',
      cargando: 'Cargando…',
      vacio: 'Todavía no hay publicaciones.',
      sinFecha: 'sin fecha',
      estados: {
        Borrador: 'Borrador',
        Pendiente: 'Pendiente',
        Programado: 'Programado',
        Publicado: 'Publicado',
        Error: 'Con error',
      },
    },
    errores: {
      driveNoConfigurado: 'Google Drive no está conectado todavía. Avisale a Javier.',
      drive: 'No se pudo subir el archivo a Drive. Probá de nuevo.',
    },
  },
  // ciclo-tareas: gestión semanal de prioridades de Ailen (reemplaza a Leads en el panel).
  tareas: {
    crear: 'Crear tarea',
    vacio: 'Todavía no tenés tareas. Creá la primera con el botón de arriba.',
    prioridad: {
      etiqueta: 'Prioridad',
      ALTA: 'Alta',
      MEDIA: 'Media',
      BAJA: 'Baja',
    },
    activar: 'Activar',
    desactivar: 'Desactivar',
    desactivada: 'No aplica esta semana',
    completar: 'Marcar como hecha',
    descompletar: 'Marcar como pendiente',
    pestanas: { tareas: 'Tareas', estadisticas: 'Estadística' },
    // ciclo-tareas-deadline (18/10/2026): vencimiento por tarea y vista Semana.
    dias: 'lun|mar|mié|jue|vie|sáb|dom',
    sinFecha: 'Sin fecha',
    vistas: { etiqueta: 'Vista', lista: 'Lista', semana: 'Semana' },
    vistaSemana: {
      hoy: 'Hoy',
      vacio: 'Nada para este día',
      arrastrar: 'Arrastrar a otro día',
    },
    // D-044 (19/10/2026): el objetivo de la semana, el texto principal del encabezado.
    objetivo: {
      etiqueta: 'Objetivo de la semana',
      placeholder: 'Objetivo de la semana: ¿qué querés lograr?',
      guardar: 'Guardar objetivo',
      guardando: 'Guardando...',
      cancelar: 'Cancelar',
      editar: 'Cambiar el objetivo',
      errorVacio: 'Escribí el objetivo de la semana',
      exito: 'Objetivo guardado',
      // Ayuda para aprender a definir objetivos (pedido de Javier, 19/10/2026).
      smart: {
        boton: 'Cómo escribir un buen objetivo (SMART)',
        titulo: 'SMART: un objetivo bien definido es',
        S: { nombre: 'Específico', detalle: 'Dice exactamente qué vas a lograr, sin vaguedades.' },
        M: { nombre: 'Medible', detalle: 'Tiene un número o una señal clara para saber si se cumplió.' },
        A: { nombre: 'Alcanzable', detalle: 'Es posible con el tiempo y los recursos de esta semana.' },
        R: { nombre: 'Relevante', detalle: 'Importa de verdad: acerca al negocio a donde quiere ir.' },
        T: { nombre: 'Temporal', detalle: 'Tiene fecha límite: esta semana, o un día puntual.' },
        ejemploTitulo: 'Ejemplo',
        ejemploMal: 'No: "Mejorar las ventas".',
        ejemploBien: 'Sí: "Responder todos los leads nuevos en menos de 24 horas, de lunes a viernes".',
      },
    },
    // Circuito planificar/ejecutar/cerrar (28/09/2026).
    semana: {
      planificando: 'Semana {n} · {mes} · planificando',
      enCurso: 'Semana {n} · {mes} · en curso',
      guardar: 'Guardar planificación',
      guardando: 'Guardando...',
      cerrar: 'Cerrar semana',
      cerrando: 'Cerrando...',
      confirmarCerrar:
        '¿Cerrar la Semana {n}? Se guarda el resultado en el historial, los checks se reinician y arranca la semana que sigue.',
      exitoGuardada: 'Planificación guardada — Semana {n} en curso',
      exitoCerrada: 'Semana {n} cerrada — arrancó la Semana {siguiente}',
      errorNoPlanificada:
        'La semana ya está guardada — no se puede modificar la lista de tareas hasta cerrarla.',
      errorNoGuardada: 'Todavía estás planificando — guardá la semana antes de tildar tareas.',
    },
    dialogo: {
      tituloCrear: 'Crear tarea',
      tituloEditar: 'Editar tarea',
      titulo: 'Título',
      descripcion: 'Descripción',
      descripcionOpcional: 'Descripción (opcional)',
      guardar: 'Guardar',
      guardando: 'Guardando...',
      crear: 'Crear',
      creando: 'Creando...',
      cancelar: 'Cancelar',
      eliminar: 'Eliminar tarea',
      eliminando: 'Eliminando...',
      confirmarEliminar: '¿Eliminar esta tarea? El historial de semanas ya registradas se conserva.',
      errorTitulo: 'El título no puede estar vacío',
      vence: 'Vence el',
      errorVence: 'Elegí un día de esta semana (del {inicio} al {fin})',
      exitoCreada: 'Tarea creada',
      exitoEditada: 'Tarea actualizada',
      exitoEliminada: 'Tarea eliminada',
    },
    estadisticas: {
      vacio: 'Todavía no hay semanas cerradas — cerrá la semana actual para ver el primer dato.',
      totalTareas: 'Tareas con historial',
      totalSemanas: 'Semanas cerradas',
      cumplimientoGlobal: 'Cumplimiento global',
      graficoTitulo: 'Cumplimiento semana a semana',
      cumplimiento: '{pct}% de cumplimiento',
      semanasRegistradas: '{n} semana(s) registrada(s)',
      peorTarea: 'La que más te cuesta cumplir: {titulo}',
      objetivosTitulo: 'Objetivo de cada semana',
      sinObjetivo: 'Sin objetivo',
    },
  },
  sistema: {
    titulo: 'Sistema',
    intro: 'El estado del VPS tal como lo dejó el recolector. Solo lectura.',
    tomado: 'Tomado hace {min} min',
    viejo: 'Estos datos tienen más de 2 horas: el recolector puede estar parado.',
    sinDatos: 'Sin datos del recolector',
    pestanas: { lineas: 'Por línea', tipos: 'Por tipo', exposicion: 'Exposición', avisos: 'Avisos' },
    kpis: {
      contenedores: 'contenedores arriba',
      workflows: 'workflows activos',
      fuera: 'fuera de lo esperado',
      publicos: 'puertos visibles de afuera',
      unaCapa: 'tapados por una sola capa',
      disco: 'disco',
      ram: 'RAM libre · load',
      uptime: 'uptime',
      leads: 'leads scrapeados',
      backup: 'último backup',
    },
    lineas: {
      ayuda: 'Cada tarjeta es una línea de trabajo. Clic para ver sus piezas.',
      esperado: 'esperado',
      cerrar: 'Cerrar',
      recibeDe: 'recibe de',
      mandaA: 'manda a',
      externos: 'externos',
    },
    tipos: {
      contenedor: 'Contenedores',
      workflow: 'Workflows de n8n',
      servicio: 'Servicios del host',
      puerto: 'Procesos locales',
      instancia_wa: 'Números de WhatsApp',
      activosDe: '{n} activos de {total}',
    },
    exposicion: {
      intro:
        'Qué escucha el host, qué lo separa de internet y qué se ve de afuera. Docker publica por FORWARD y saltea el INPUT DROP de iptables.',
      capas: 'Las 12 capas',
      bandas: {
        expuesto: 'Responde desde internet y NO estaba previsto',
        una_capa: 'Tapado por UNA sola capa',
        ok: 'Previsto, dos capas, o solo local',
      },
      ninguno: 'Ninguno.',
      columnas: {
        puerto: 'puerto',
        servicio: 'servicio',
        escucha: 'escucha en',
        separa: 'lo separa de internet',
        sondeo: 'sondeo',
      },
      todas: '0.0.0.0 (todas)',
      local: '127.0.0.1',
      privada: 'red privada',
      abierto: 'ABIERTO',
      previsto: 'previsto',
    },
    avisos: { vacio: 'Nada fuera de lo esperado.' },
  },
} as const;

// Ensancha los literales (`'Entrar'`) a `string` para poder tipar diccionarios
// de otros idiomas: cualquier idioma DEBE tener las mismas claves que `es`, con
// cualquier string como valor. Si a `en` le falta (o le sobra) una clave, el
// typecheck falla — así se mantienen sincronizados.
type Widen<T> = T extends string ? string : { -readonly [K in keyof T]: Widen<T[K]> };

export type I18nKeys = typeof es;
export type I18nDict = Widen<typeof es>;
